import React, { Component } from 'react';
import Box from '../componentes/Box';
import Request from '../Request';

class Manuais extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manuais: {}
    };
    this.baixarManualClick = this.baixarManualClick.bind(this);
  }

  componentDidMount() {
    Request.get('manual', (manuais) => {
      this.setState({ manuais: manuais });
    });
  }

  baixarManualClick(event) {
    Request.baixarManual(Request.getApiUri() + 'manual/' + event.target.value, (error) => {
      this.box.showAlert(error);
    });
    event.preventDefault();
  }

  renderManuais() {
    if (this.state.manuais) {
      return Object.keys(this.state.manuais).map(
        (nomeManual, nomeArquivo) => {
          return (
            <li key={nomeArquivo}>
              <button type="button" className="btn btn-link" onClick={this.baixarManualClick} value={nomeManual}>{nomeManual}</button>
            </li>
          );
        }
      );
    }
  }

  render() {
    return (
      <Box ref={(box) => { this.box = box; }} titulo="Manuais">
        <ul className="list-unstyled">
          {this.renderManuais()}
        </ul>
      </Box>
    );
  }
}

export default Manuais;


// WEBPACK FOOTER //
// ./src/modulos/manuais/Manuais.js